document.addEventListener('turbolinks:load', function() {
    if ($("#swagger").length) {
        SwaggerUI({
            dom_id: '#swagger',
            url: "/v1/swagger",
            docExpansion: 'none'
        });
    }
});
